import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'

import Button from 'components/Button'
import content from 'prismic-translates/pwa-provider.json'

import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

export default function Android() {
  return (
    <>
      <div className={classes.text}>{t('android_message')}</div>
      <div className={classes['button-wrapper']}>
        <Button className={classes.button} size='small'>
          {t('android_button')}
        </Button>
      </div>
    </>
  )
}
